import { render, staticRenderFns } from "./aiAgent.vue?vue&type=template&id=5915ac40&scoped=true"
import script from "./aiAgent.vue?vue&type=script&lang=js"
export * from "./aiAgent.vue?vue&type=script&lang=js"
import style0 from "./aiAgent.vue?vue&type=style&index=0&id=5915ac40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5915ac40",
  null
  
)

export default component.exports